module.exports = __webpack_public_path__ + "img/event_icon_breweryrelease_white.a980ee32.png";